import {toast, ToastOptions, ToastPosition, TypeOptions} from "react-toastify";

const AlertPosition: ToastPosition = "top-right";

const showToast = (message: string, type: TypeOptions = 'info', options: ToastOptions = {}) => {

    const toastOptions: ToastOptions = {
        pauseOnFocusLoss: false,
        // closeButton: AlertCloseButton,
        ...options,
        autoClose: 1500,
    };

    switch (type) {
        case 'info':
            toast.info(message, toastOptions);
            break;
        case 'success':
            toast.success(message, toastOptions);
            break;
        case 'error':
            toast.error(message, toastOptions);
            break;
        case 'warning':
            toast.warning(message, toastOptions);
            break;
        default:
            toast.dark(message, toastOptions);
            break;
    }
}

const AlertService = {
    showToast,
    AlertPosition
}

export default AlertService;
